import { useStore } from 'zustand';
import { FinanceOption, ModelType, TrimType } from '../../../types';
import { formatNumber } from '../../../utils/helpers';
import CarouselCardRow from './CarouselCardRow';
import CarouselLoanDisclaimer from './CarouselLoanDisclaimer';
import { getStoreByKey } from './store/CarouselStore';
import { CarouselFieldsEnum } from './types/CarouselTypes';

interface Props {
  trim: TrimType;
  model: ModelType;
  uniqId: string;
}

const CarouselLoanRows = ({ trim, model, uniqId }: Props) => {
  const { options, selectedFinanceOption } = useStore(getStoreByKey(uniqId));

  const shouldRenderInPriceList =
    Boolean(
      !options &&
        (!selectedFinanceOption ||
          selectedFinanceOption === FinanceOption.LOAN),
    ) || options?.fields?.includes(CarouselFieldsEnum.LOAN);
  // console.log(trim.name, ' : ', trim.loan[0]?.incl_service_agreement);
  return (
    <>
      {trim.loan?.length ? (
        <>
          {shouldRenderInPriceList ||
          options?.fields?.includes(CarouselFieldsEnum.LOAN) ? (
            <CarouselCardRow
              uniqId={uniqId}
              tooltip="Billån med kontantinsats 30%, 36 mån 4500 mil"
              label="Billån inkl. serviceavtal"
            >
              <p>
                Från {formatNumber(trim.loan[0]?.incl_service_agreement)} kr/mån
              </p>
              <p className="!text-xs">
                {trim.loan[0].disclaimer ?? 'Ingen information'}
              </p>
              <CarouselLoanDisclaimer />
            </CarouselCardRow>
          ) : null}
        </>
      ) : null}
    </>
  );
};

export default CarouselLoanRows;
